import { Hero } from '../components/sections/Hero';
import { About } from '../components/sections/About';
import { Comparison } from '../components/sections/Comparison';
import { HowItWorks } from '../components/sections/HowItWorks';
import { KeyFeatures } from '../components/sections/KeyFeatures';
import { WhyNimblepark } from '../components/sections/WhyNimblepark';
import { Testimonials } from '../components/sections/Testimonials';
import { Faq } from '../components/sections/Faq';
import { Articles } from '../components/sections/Articles';
import { AssociatePortal } from '../components/sections/AssociatePortal';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/** Section order follows the comp top to bottom. Demo + Footer come from Layout. */
export function Landing() {
  useDocumentTitle(
    'NimblePark | Smart Valet & Parking Management',
    'Digitize valet operations, parking management, vehicle tracking and staff management through a single platform.',
  );

  return (
    <>
      <Hero />
      <About />
      <Comparison />
      <HowItWorks />
      <KeyFeatures />
      <WhyNimblepark />
      <Testimonials />
      <Faq />
      <Articles />
      <AssociatePortal />
    </>
  );
}

export default Landing;
